
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyBN8_78l4xSGgw0kGcfnZb6l0ztcBvTvio",
  authDomain: "visual-impairment-eafd5.firebaseapp.com",
  projectId: "visual-impairment-eafd5",
  storageBucket: "visual-impairment-eafd5.firebasestorage.app",
  messagingSenderId: "509766571605",
  appId: "1:509766571605:web:d57a88b7d9e8cec28ca6dc"
};

  

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export







